import React from 'react';
import { Box, Flex, Link, Image, HStack, IconButton, Menu, MenuButton, MenuList, MenuItem, useDisclosure } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';

const Navbar = () => {
  const { isOpen, onToggle } = useDisclosure();

  const menuItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/rewards', label: 'Rewards' },
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/whitepaper', label: 'Whitepaper' },
  ];

  return (
    <Box bg="navy" px={4} position="fixed" width="100%" top={0} zIndex={1000}>
      <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
        <RouterLink to="/">
          <Image h="40px" src="/hodl-logo.svg" alt="HODL" />
        </RouterLink>

        {/* Desktop Menu */}
        <HStack spacing={8} alignItems={'center'} display={{ base: 'none', md: 'flex' }}>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              as={RouterLink}
              to={item.path}
              color="cyan.400"
              _hover={{ color: 'cyan.300' }}
            >
              {item.label}
            </Link>
          ))}
        </HStack>

        {/* Mobile Menu */}
        <Box display={{ base: 'block', md: 'none' }}>
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Open Menu"
              icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
              variant="ghost"
              color="cyan.400"
              onClick={onToggle}
              _hover={{ color: 'cyan.300' }}
              _active={{ bg: 'transparent' }}
            />
            <MenuList 
              bg="navy" 
              borderColor="cyan.900"
              boxShadow="lg"
              py={2}
            >
              {menuItems.map((item) => (
                <MenuItem
                  key={item.path}
                  as={RouterLink}
                  to={item.path}
                  color="cyan.400"
                  bg="navy"
                  _hover={{ bg: 'cyan.900', color: 'cyan.300' }}
                  onClick={onToggle}
                  py={3}
                  px={6}
                >
                  {item.label}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>
        </Box>
      </Flex>
    </Box>
  );
};

export default Navbar; 